import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { Socials } from "./Socials";
import { scrollToId } from "./Reveal";
import { CONTACT } from "../../data";
import { useLang } from "../../i18n";

const LINK_IDS = ["programs", "classifications", "pricing", "reviews", "quote"];

export const Footer = () => {
  const { t } = useLang();
  const f = t.footer;
  return (
    <footer data-testid="site-footer" className="relative bg-[#040814] border-t border-white/10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-5 text-slate-400 text-sm leading-relaxed max-w-sm">{f.desc}</p>
            <div className="mt-6 flex flex-col gap-3">
              <a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-3 text-white hover:text-amber-400 transition-colors">
                <Phone size={16} className="text-amber-400" /> {CONTACT.phone}
              </a>
              <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-slate-300 hover:text-amber-400 transition-colors text-sm">
                <Mail size={16} className="text-amber-400" /> {CONTACT.email}
              </a>
              <span className="flex items-center gap-3 text-slate-400 text-sm">
                <MapPin size={16} className="text-amber-400" /> {f.serving}
              </span>
            </div>
            <Socials className="mt-6" />
          </div>

          <div className="md:col-span-3">
            <h4 className="font-mono-x text-[11px] uppercase tracking-[0.25em] text-amber-400 mb-5">{f.explore}</h4>
            <ul className="space-y-3 text-sm">
              {f.exploreLinks.map((label, i) => (
                <li key={i}>
                  <button onClick={() => scrollToId(LINK_IDS[i])} className="text-slate-400 hover:text-white transition-colors">
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-mono-x text-[11px] uppercase tracking-[0.25em] text-amber-400 mb-5">{f.whyTitle}</h4>
            <ul className="space-y-2.5 text-sm">
              {f.benefits.map((b) => (
                <li key={b} className="flex items-start gap-2.5 text-slate-400">
                  <span className="h-1.5 w-1.5 rounded-full bg-amber-400 mt-1.5 shrink-0" />
                  {b}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} Golden State Safety Certifications LLC. {f.rights}
          </p>
          <p className="font-mono-x text-[11px] uppercase tracking-widest text-slate-600">
            {f.compliant} · {CONTACT.domain}
          </p>
        </div>
      </div>
    </footer>
  );
};
